import React from "react"

import AboutUsSection from "../../Sections/AboutUsSection/Content"
const AboutUsPage = () => {
    return (
      <AboutUsSection/>
    )
}
export default AboutUsPage